import { useMemo } from 'react';
import { generateHTML } from '@tiptap/core';

import {
  getExtensions,
  isRichtextEmpty,
} from 'approot/shared/richtext/richtext.utils';
import {
  SUB_ACTIVITY_INSTRUCTION_SETTINGS,
  ViewProps,
} from './sub-activity.constants';
import * as Styled from './sub-activity-view.style';
import { formatSubActivityLabel } from './sub-activity.utils';

const SubActivityPrint = ({
  children,
  subActivityDetails,
  isZoomed,
}: ViewProps & {
  isZoomed?: boolean;
}) => {
  const extensions = useMemo(
    () => getExtensions(SUB_ACTIVITY_INSTRUCTION_SETTINGS),
    []
  );

  if (!subActivityDetails) return null;
  const { instructions, subActivityLabel } = subActivityDetails;
  return (
    <Styled.SubActivity>
      <Styled.SubActivityLabelWrapper>
        {subActivityLabel && (
          <Styled.SubActivityLabel $isZoomed={isZoomed}>
            {formatSubActivityLabel(subActivityLabel)}{' '}
          </Styled.SubActivityLabel>
        )}
        {subActivityDetails.areInstructionsVisible &&
          !isRichtextEmpty(instructions) && (
            <Styled.SubActivityInstruction
              $isZoomed={isZoomed}
              dangerouslySetInnerHTML={{
                __html: isRichtextEmpty(instructions)
                  ? ''
                  : generateHTML(instructions, extensions),
              }}
            />
          )}
      </Styled.SubActivityLabelWrapper>

      {children}
    </Styled.SubActivity>
  );
};

export default SubActivityPrint;
